import Axios from "axios"
import { sortCaret } from "../../../_metronic/_helpers";
/* const url_categories_dev = "http://localhost:5000/gt-out/us-central1/api/v1/categories"; */
const url = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/payments";

export const columns = [
  {
    dataField: "name",
    text: "Categories Name",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "description",
    text: "Description",
    sort: true,
sortCaret: sortCaret,
  }
];

export function getClients(callback) {
  Axios.get(`${url}/find`)
    .then((res) => {
      callback(res.data.payload);
    })
    .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
          console.log(`request cancelled:${thrown.message}`)
      } else {
          console.log('another error happened')
      }
  })
}
export function getClient(uid) {
  return Axios.get(`${url}/find/${uid}`)
 
}
export function updateClient(document) {
  if(document.uid){

    return Axios.put(`${url}/update/${document.uid}`, document);
  }else{
    return Axios.post(`${url}/create`, document);

  }
}
export function deleteClient(uid){
  return Axios.delete(`${url}/delete/${uid}`)
}